export default {
  ID_PROPERTY: 'id',
  REQUEST: 'request',
  PROBLEM: 'problem',
  CHANGE: 'change',
  RELEASE: 'release',
  ASSET: 'asset',
  TASK: 'task',
  ADMIN: 'admin',
  APPROVAL_STAGE: 'approval_stage',
  SERVICE_CATALOG: 'service_catalog',
  ASSET_MOVEMENT: 'asset_movement',
  ASSET_CONFIGURATION: 'asset_configuration',
  ASSET_CONFIGURATION_DEPLOYMENT: 'asset_configuration_deployment',
  USER: 'user',
  USER_LEAVE: 'user_leave',
  FEEDBACK: 'feedback',
  KNOWLEDGE: 'knowledge',
  REPORT: 'report',
  REPORT_HISTORY: 'report_history',
  PRODUCT: 'product',
  VENDOR: 'vendor',
  ASSET_HARDWARE: 'asset_hardware',
  ASSET_SOFTWARE: 'asset_software',
  ASSET_GEOLOCATION: 'asset_geolocation',
  ASSET_NON_IT: 'asset_non_it',
  ASSET_CONSUMABLE: 'asset_consumable',
  CONTRACT: 'contract',
  PURCHASE: 'purchase',
  USER_SURVEY: 'user_survey',
  USER_SURVEY_RESPONSE: 'user_survey_response',
  USER_SURVEY_SCHEDULE: 'user_survey_schedule',
  AGENT: 'agent',
  DISCOVERY: 'discovery',
  POLLER: 'poller',
  CREDENTIAL_PROFILE: 'credential_profile',
  SOFTWARE_LICENSE: 'software_license',
  DEPARTMENT: 'department',
  LOCATION: 'location',
  GEOLOCATION: 'geolocation',
  MANUFACTURER: 'manufacturer',
  SNMP_PROPERTY_DEVICE: 'snmp_property_device',
  BASELINE: 'baseline',
  PRODUCTVENDOR: 'productvendor',
  CATEGORY: 'category',
  DEPENDENT_VALUE: 'dependent_value',
  SINGLE_COLUMN: 'single_column',
  DAY_OF_YEAR: 'day_of_year',
  // patch related modules
  OSAPPLICATION: 'osapplication',
  REMOTE_OFFICE: 'remote_office',
  MY_TEAM: 'my_team',

  COMPUTER: 'computer',
  PATCH_COMPUTERS: 'patch_computers',
  PACKAGES_COMPUTERS: 'packages_computers',

  PATCH: 'patch',
  WINDOWS_PATCH: 'windows_patch',
  PROJECT: 'project',
  REGISTRY: 'registry',

  REMOTE_DEPLOYMENT: 'remote_deployment',
  PATCH_REMOTE_DEPLOYMENT: 'patch_remote_deployment',

  PACKAGE: 'pakage',
  PACKAGES_REMOTE_DEPLOYMENT: 'packages_remote_deployment',
  REGISTRY_REMOTE_DEPLOYMENT: 'registry_remote_deployment',

  DEPLOYMENT: 'deployment',
  PACKAGES: 'packages',
  REGISTRY_TEMPLATE: 'registry_template',
  DASHBOARD: 'dashboard',

  REQUESTER: 'requester',
  TECHNICIAN: 'technician',

  APPROVAL: 'approval',
  APPROVER: 'approver',
  CREDENTIAL: 'credential',
  IP_NETWORK: 'ip_network',
  CLOUD_NETWORK: 'cloud_network',
  PRIVATE_CLOUD_NETWORK: 'private_cloud_network',
  SNMP_PROPERTY: 'snmp_property',
  AUTO_TICKET_CREATE: 'auto_ticket_create',
  AUTO_TASK_CREATE: 'auto_task_create',
  MSP_COMPANY: 'company',

  CURRENT_DATE_VALUE: -919191,
  CURRENT_DATE_TODAY: 'today',

  CHAT: 'chat',
  CHATBOT: 'chatbot',

  SLA_POLICY: 'sla_policy',
  QUANTITY_DETAILS: 'quantity_details',
  ALLOCATION_DETAIL: 'allocation_detail',
  ASSET_FIELD_TRANSITION_HISTORY: 'asset_field_transition_history',
  CI_FIELD_TRANSITION_HISTORY: 'ci_field_transition_history',
  USER_IMPORT_HISTORY_DETAILS: 'user_import_history_details',
  SSO_PROGRESS_DATA: 'sso_progress_data',
  CUSTOM_SSO_PROGRESS_DATA: 'custom_sso_progress_data',
  LDAP_PROGRESS_DATA: 'ldap_progress_data',

  ANNOUNCEMENT: 'announcement',

  EMAIL_TO_TICKET: 'email_to_ticket',

  ASSET_UPDATE: 'asset_update',
  MAKER_CHECKER: 'maker_checker',

  CMDB: 'cmdb',
  CI: 'ci',
  REQUEST_TEMPLATE: 'request_template',
  PROBLEM_TEMPLATE: 'problem_template',
  CHANGE_TEMPLATE: 'change_template',
  RELEASE_TEMPLATE: 'release_template',

  SOFTWARE_NORMALIZATION: 'software_normalization',
  SOFTWARE_UNINSTALLTION_TASK: 'software_uninstalltion_task',

  USB_CONFIGURATION: 'usb_configuration',

  COMMAND_RD_PRD: 'command_remotedeployment_patch_remote_deployment',
  COMMAND_RD_PKGRD: 'command_remotedeployment_packages_remote_deployment',
  COMMAND_RD_REGRD: 'command_remotedeployment_registry_remote_deployment',
  COMMAND_P_PRD: 'command_patch_patch_remote_deployment',
  COMMAND_CP: 'command_computer_patch',
  COMMAND_CPKG: 'command_computer_packages',
  COMMAND_CREG: 'command_computer_registry',
  PRINT_TEMPLATE: 'print_template',
  AUDIT: 'audit',
  ASSET_REPAIR_HISTORY: 'asset_repair_history',
  WOL_HISTORY: 'wol_history',
  ASSET_USAGE_DETAILS: 'asset_usage_details',
  ASSET_CHANGE_LOG: 'asset_change_log',
  ASSET_SCAN_AUDIT: 'asset_scan_audit',
  DISCOVERY_AGENT: 'discovery_agents',
  SEND_TO_REPAIR: 'send_to_repair',
  RETURN_FROM_REPAIR: 'return_from_repair',
  ASSET_TRANSFER: 'asset_transfer',
  CREDENTIAL_BASED: 'credential_based',
  CREDENTIAL_LESS: 'credential_less',
  IP_RANGE_LOCATION: 'ip_range_location',
  IPRANGELOCATION: 'iprangelocation',
  EMAIL: 'email',
  EMAIL_INCOMING_ADMIN_AUDIT: 'email_incoming_admin_audit',
  EMAIL_OUTGOING_ADMIN_AUDIT: 'email_outgoing_admin_audit',
  RDP_AGENT: 'rdp_agent',
  ADMIN_AUDIT: 'admin_audit',
  EMAIL_ADMIN_AUDIT: 'email_admin_audit',
  USER_SESSION: 'user_session',
  OPERATION_AUDIT: 'operation_audit',
  INTEGRATION_CONNECTOR: 'integration_connector',
  FILE_SERVER: 'file_server',
  FILE_SERVER_BUILD_HISTORY: 'file_server_build_history',
  DOWNLOAD: 'download',
}
